import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "a-picture" }
const _hoisted_3 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(['o-mainHeader__logo', {'is-svg': _ctx.logo.isSvg}]),
    href: _ctx.logo.url,
    title: _ctx.logo.name,
    "data-js": "logo",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogoClick && _ctx.handleLogoClick(...args)))
  }, [
    _createElementVNode("picture", _hoisted_2, [
      _createElementVNode("img", {
        class: "o-mainHeader__logoImg",
        id: "logo",
        itemprop: "image",
        alt: _ctx.logo.description,
        src: _ctx.logo.imgPath
      }, null, 8, _hoisted_3)
    ])
  ], 10, _hoisted_1))
}